export default __webpack_public_path__ + "static/media/logo.74e5a2cc.svg";